import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { RfpClientOneFileAllConfirmView } from '@/components/pages/rfp/client/RfpClientOneFileAllConfirmView';
import RfpOneArrowLink from '@/container/Client/Rfp/One/Parts/Head/RfpOneArrowLink';
import RfpContentSubMenu from '@/container/Client/Rfp/One/Parts/SubMenu/RfpContentSubMenu';
import { rfpOneUseCase } from '@/container/Client/Rfp/One/UseCase/RfpOneUseCase';
import Layout from '@/container/Layout';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { useRfpClientOneFileFetchAll } from '@/pages/rfp/client/RfpClientOneFileAll/useRfpClientOneFileAllFetch';
import { useRfpClientOneFileAllConfirmSubmit } from '@/pages/rfp/client/RfpClientOneFileAllConfirm/useRfpClientOneFileAllConfirmSubmit';
export const RfpClientOneFileAllConfirmPage = (props) => {
    const { formDispatch, initialValues, offers, profile, rfp, users } = props;
    const auth = useTypeSelector((state) => state.auth);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    const { fetchViewRequest } = useRfpClientOneFileFetchAll({
        dispatch,
        formDispatch,
        id: rfp.id,
        unmountRef,
    });
    const { onSubmit } = useRfpClientOneFileAllConfirmSubmit({
        dispatch,
        formDispatch,
        id: rfp.id,
        // submit後のデータを反映させるため、閲覧申請データを引き直す
        onSubmitCallback: fetchViewRequest,
        unmountRef,
    });
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container rfp_client_one_container' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${rfp.name}｜PROFFIT` }) }), _jsx(RfpClientOneFileAllConfirmView, { id: rfp.id, initialValues: initialValues, isCallEnd: rfp.is_call_end, onSubmit: onSubmit, stepComponent: _jsx(RfpOneArrowLink, { activeIndex: 1, offers: offers, rfp: rfp }), subContentComponent: _jsx(RfpContentSubMenu, { isCanUpdateMember: isCanUpdateMember, isMemberAdmin: isMemberAdmin, members: members, rfp: rfp }), title: rfp.name, unansweredQuestionCount: rfp.unanswered_online_question_count, unapprovedCount: rfp.view_request_unapproved_count, unreadFileCount: rfp.unread_share_document_message_count, unreadMessageCount: rfp.unread_negotiate_message_count, users: users })] })));
};
